module.exports = __webpack_public_path__ + "static/media/anni_title.a7884ae5.png";